export default __webpack_public_path__ + "static/media/happyFace.652282f1.svg";